import { useTranslation } from 'react-i18next';

export type SkipToContentProps = {
  /** The ID of the content block to jump to. Default to main-content */
  contentElementID?: string;
};

export default function SkipToContent({ contentElementID = 'main-content' }) {
  const { t } = useTranslation(['common']);
  return (
    <a href={`#${contentElementID}`} className="sr-only sr-only-focusable">
      {t('common:actions.skipToContent')}
    </a>
  );
}
